import { AbstractControl, ValidationErrors } from '@angular/forms';

export function specialCharactersValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.value) {
    return null;
  }
  const regex = /^[\p{L}0-9#\-,.&;/:'\s]*$/u;
  return regex.test(control.value) ? null : { specialCharacters: true };
}
